/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_ReleasedInputs */

const en_landing_why_released = /** @type {(inputs: Landing_Why_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

const zh_landing_why_released = /** @type {(inputs: Landing_Why_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布时间`)
};

/**
* | output |
* | --- |
* | "Released" |
*
* @param {Landing_Why_ReleasedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_released = /** @type {((inputs?: Landing_Why_ReleasedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_ReleasedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_released(inputs)
	return zh_landing_why_released(inputs)
});
export { landing_why_released as "landing.why.released" }